export const ProjectCompletionRate = Backbone.Marionette.Layout.extend({
    template: '#tpl_dashboard_project_compliance_completion_rate',
    model: null, // CompletionRate
    className: 'card',

    dateRange: null, // int

    initialize: function (options) {
        options = options || {};
        this.validateRequiredArguments(options);
        $.extend(this, options);
    },

    validateRequiredArguments: function (options) {
        const { dateRange } = options;
        const requiredFields = [dateRange];

        if (requiredFields.some(_.isUndefined)) {
            throw new Error('Programmer Error: ProjectCompletionRate must have a dateRange');
        }
    },

    templateHelpers: function () {
        const completion_rate = this.model.get('completion_rate');
        const completion_percentage = $f.utils.round(completion_rate * 100);
        const is_pass = completion_percentage > 50;
        return {
            completion_percentage: completion_percentage,
            title: _t('mobile_compliance_completion_rate_in_last_days', { days: this.dateRange }),
            completion_rate_class: is_pass ? 'pass' : 'fail'
        };
    }
});
